<template>
    <div class="container mx-auto px-2 py-4">
    <h1>Redaktion</h1>
       <p>
            Dipl.-Ing. Ingram Täschner<br>
            Fachgebietsleiter Biogas und Erdgasanwendungen<br>
            BDEW Bundesverband der Energie- und Wasserwirtschaft e.V.<br>
            E-Mail: <a href="mailto:ingram.taeschner@bdew.de" class="text-primary-default">ingram.taeschner@bdew.de</a><br>
            Web: <a href="https://www.bdew.de/" class="text-primary-default" target="_blank">www.bdew.de</a></p> <p>
            Der BDEW-Heizkostenvergleich wurde im Auftrag des BDEW erstellt vom Institut für Technische Gebäudeausrüstung Dresden Forschung und Anwendung GmbH.
        </p>
        <br>
        <p><b>Layout und technische Realisation:</b><br>
            Friendventure Digitalagentur<br> <a href="https://www.friendventure.de/" class="text-primary-default" target="_blank">www.friendventure.de</a></p> <p>
            Stand: August 2021
        </p>

    </div>
</template>

<script>
import Slider from '@vueform/slider'

export default {
    components: { Slider },
    data: () => ({
        value: 20
    })
}
</script>
